<template lang="pug">
  mt-map(
    @mt-zoomend='handleMapZoomEnd',
    ref='map',
    :options='mapOptions')
    mt-vector-layer(name='vector-1')
      mt-line-string(
        v-for='routeGeofence in routeGeofenceList',
        :key='routeGeofence.id',
        :coordinates='routeGeofence.coordinates',

        :line-width='routeGeofenceLineWidth',
        :line-color='routeGeofence.color',
        :text-name='routeGeofence.name')
      mt-circle(
        v-for='circularGeofence in circularGeofenceList',
        :key='circularGeofence.id',
        :center='circularGeofence.center',
        :radius='circularGeofence.radius',

        :polygon-fill='circularGeofence.color',
        :text-name='circularGeofence.name')
    mt-vector-layer(:options='{}', vector='vector-2')
      mt-marker(
        v-for='bus in busList',
        :key='bus.id',
        :coordinates='[bus.longitude, bus.latitude]',
        :text-name='bus.name',
        :text-fill='bus.color',
        :heading='bus.heading',
        :is-seen='filteredBusIds.includes(bus.id)')
    //- mt-three-layer
      mt-three-object(
        v-for='bus in busList',
        :key='bus.id',
        :coordinates='{ x: bus.longitude, y: bus.latitude }',
        :heading='bus.heading',
        :color='bus.color',
        :is-selected='bus.id === selectedBus',
        :is-seen='filteredBusIds.includes(bus.id)',
        @loaded='handleThreeObjectLoaded')

</template>

<script>
import Map from '@/components/map/Map'
import Marker from '@/components/map/Marker'
import VectorLayer from '@/components/map/VectorLayer'
import CircleLayer from '@/components/map/CircleLayer'
import LineStringLayer from '@/components/map/LineStringLayer'
import ThreeLayer from '@/components/map/ThreeLayer'
import ThreeObject from '@/components/map/ThreeObject'
import {
  GEOFENCE_CIRCULAR,
  GEOFENCE_ROUTE,
  MAP_DEFAULT_ZOOM,
  MAP_DEFAULT_ROUTE_WIDTH,
  MAP_DEFAULT_PITCH,
  MAP_MAX_PITCH,
  MAP_CENTER } from '@/app.config'

import apiGeofence from '@/api/geofence'
import deepFreeze from '@/utils/deepFreeze'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'main-map',
  components: {
    'mt-map': Map,
    'mt-marker': Marker,
    'mt-vector-layer': VectorLayer,
    'mt-circle': CircleLayer,
    'mt-line-string': LineStringLayer,
    'mt-three-layer': ThreeLayer,
    'mt-three-object': ThreeObject
  },
  created () {
    this.getGeofenceList()
    // setTimeout(() => {
    //   this.$refs.map.mapObject.animateTo({
    //     zoom: MAP_DEFAULT_ZOOM + 1,
    //     center: MAP_CENTER,
    //     pitch: MAP_DEFAULT_PITCH
    //   }, {
    //     duration: 500,
    //     easing: 'out'
    //   })
    // }, 5000)
  },
  data () {
    return {
      geoFenceList: [],
      mapOptions: {
        zoom: MAP_DEFAULT_ZOOM,
        pitch: MAP_DEFAULT_PITCH,
        maxPitch: MAP_MAX_PITCH,
        center: MAP_CENTER,
        dragPitch: true,
        dragRotate: true
      },
      markerOptions: {
        visible: true,
        symbol: {
          textWeight: 'bold',
          textSize: 11,
          textOpacity: 1,
          textHaloRadius: 0,
          textFill: '#fff'
        }
        // properties: {
        //   altitude: 100
        // }
      },
      routeGeofenceLineWidth: MAP_DEFAULT_ROUTE_WIDTH
    }
  },
  methods: {
    ...mapActions('map', [
      'countLoadedObjects'
    ]),
    getGeofenceList () {
      apiGeofence
        .getList()
        .then(({ data: { data } }) => {
          this.geoFenceList = deepFreeze(data)
        })
        .catch(({ response: { data: { message = 'Алдаа' } } }) => {
          // TODO: fail msg
        })
    },
    handleMapZoomEnd () {
      if (!this.$refs.map) return

      const zoom = this.$refs.map.mapObject.getZoom()
      const diff = (zoom - MAP_DEFAULT_ZOOM)
      const scale = Math.pow(2, diff)

      this.routeGeofenceLineWidth = MAP_DEFAULT_ROUTE_WIDTH * scale
    },
    handleThreeObjectLoaded () {
      this.countLoadedObjects()
    }
  },
  computed: {
    ...mapGetters('bus', [
      'busList',
      'selectedBus'
    ]),
    ...mapGetters('tag', [
      'selectedTagId',
      'selectedTag'
    ]),
    filteredGeoFenceList () {
      return this.geoFenceList.filter(({ tags }) => tags.includes(this.selectedTagId))
    },
    filteredBusIds () {
      const ha = this.selectedTag ? this.selectedTag.usersIds : []
      return this.selectedTag ? this.selectedTag.usersIds : []
    },
    circularGeofenceList () {
      return this.filteredGeoFenceList
        .filter(({ type }) => type === GEOFENCE_CIRCULAR)
        .map(({ id, color, name, shape: { center: { lng, lat }, radius } }) => ({
          id,
          color,
          name,
          center: [lng, lat],
          radius
        }))
    },
    routeGeofenceList () {
      return this.filteredGeoFenceList
        .filter(({ type }) => type === GEOFENCE_ROUTE)
        .map(({ id, color, name, shape: { vertices } }) => ({
          id,
          color,
          name,
          coordinates: vertices.map(({ lng, lat }) => [lng, lat])
        }))
    }
  }
}
</script>

<style scoped>
</style>
